// Local translations
export const T = {
  en_GB: {
    settings: "Settings",
    pdfTemplates: "PDF Templates",
    pageDescription: "Create and manage PDF templates for your flows",
    documentation: "Documentation",
    createBlank: "Create Blank",
    createTemplate: "Create from Template",
  },
  nb_NO: {
    settings: "Innstillinger",
    pdfTemplates: "PDF-maler",
    pageDescription: "Opprett og administrer PDF-maler for dine flyter",
    documentation: "Dokumentasjon",
    createBlank: "Opprett tom",
    createTemplate: "Opprett fra mal",
  },
} as const;
